import React from "react";
import { Container, Box, Paper, Typography } from "@mui/material";

const Social: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: "#1E1E2F",
        py: 8,
        userSelect: 'none'
      }}
    >
      <Container maxWidth="lg">
        {/* Timeline Embed */}
        <Paper
          elevation={6}
          sx={{
            display: "flex",
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: "center",
            p: 2,
            borderRadius: 3,
            overflow: "auto",
            bgcolor: "#242435",
          }}
        >
          <Typography
          id="social"
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            color: "#e0e0e0",
            fontWeight: 600,
            mb: 4,
          }}
        >
          Shop Updates
        </Typography>
          <Box
            sx={{
              minWidth: 340,
              width: "100%",
              maxWidth: 500,
              height: 500,
            }}
          >
            <iframe
              title="Facebook Page Timeline"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprimetimesportscards&tabs=timeline&width=500&height=500&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false"
              width="500"
              height="500"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Social;
